import { Link } from "react-router-dom";
import { NavBar, Footer, GetReady, Gallary, AboutBox } from "../../Components/ExportComponents";
import { Helmet } from "react-helmet";

import "./About.css";
const About = () => {
    document.title = "ScaleUp Academy | About"
    return (
        <>
            <Helmet>
                <title>About | Best IT, Design & Marketing Training in Pokhara | Scaleup Academy</title>

                {/* Geo Tags */}
                <meta name="geo.region" content="NP-GA" />
                <meta name="geo.placename" content="Pokhara" />
                <meta name="geo.position" content="28.2096;83.9856" />
                <meta name="ICBM" content="28.2096, 83.9856" />

                {/* SEO Meta Tags */}
                <meta
                    name="description"
                    content="Explore Scaleup Academy's top courses in Pokhara: Graphic Design, UI/UX Design, Digital Marketing, and Video Editing. Learn hands-on skills in Photoshop, Figma, Adobe Premiere, SEO, and social media marketing with expert instructors. Build portfolios, start freelancing, and advance your career."
                />
                <meta
                    name="keywords"
                    content="Best Graphic Design Course in Pokhara, Best UI/UX Course in Pokhara, Digital Marketing Classes Pokhara, Video Editing Course Pokhara, Scaleup Academy, IT Training Nepal, Tech Courses Nepal, Web Design Classes, Adobe Photoshop, Figma, Premiere Pro, SEO Training Nepal"
                />
                <meta name="author" content="Scaleup Academy" />

                {/* Open Graph / Social Media Tags */}
                <meta property="og:title" content="Courses | Best IT, Design & Marketing Training in Pokhara" />
                <meta
                    property="og:description"
                    content="Join Scaleup Academy in Pokhara and learn Graphic Design, UI/UX, Digital Marketing, and Video Editing from expert instructors. Gain practical skills, build your portfolio, and kickstart your career in tech and creative fields."
                />
                <meta property="og:image" content="https://scale-upacademy.com/logo.png" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://scale-upacademy.com/courses" />

                {/* Optional: Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Courses | Best IT, Design & Marketing Training in Pokhara" />
                <meta
                    name="twitter:description"
                    content="Scaleup Academy offers Graphic Design, UI/UX, Digital Marketing, and Video Editing courses in Pokhara with hands-on training. Build skills, portfolios, and freelancing opportunities."
                />
                <meta name="twitter:image" content="https://scale-upacademy.com/logo.png" />
            </Helmet>


            <NavBar />
            <div className="AboutPage ">
                <div className='forNiddle'><div className="needleLine"></div></div>
                <AboutBox />

                <div className="aboutUsText">
                    <span className="span topAbout"></span>
                    <span className="span bottomAbout"></span>
                    <span className="span rightAbout"></span>
                    <div className="span aboutTextLeft">
                        <span></span>
                        <h1>We're<br />
                            Here to Build Skills<br />
                            That Build Futures
                        </h1>
                    </div>

                    <div className="aboutTextRight">
                        <p>At ScaleUp Academy, we believe that learning should be practical, fun, and future-focused. From design to development, we craft programs that turn curiosity into career-ready skills.</p>
                    </div>
                </div>

            </div>
            <div className="btnNLink">
                <div className="buttonAbout">
                    <Link to={"/courses"}>
                        <span>Explore Courses</span>
                        <span>Explore Courses</span>
                    </Link>

                    <Link to={"/contact"} className="hideOver">
                        <span></span>
                        <div className="text">Enroll now</div>
                    </Link>
                </div>
                <div className="linksSocialBtn">
                    <Link target="blank" to={"https://www.facebook.com/profile.php?id=61579107479784"}>
                        <span>Facebook</span>
                        <span>Facebook</span>
                    </Link>

                    <Link target="blank" to={"https://www.instagram.com/scaleupacademy.co/"}>
                        <span>Instagram</span>
                        <span>Instagram</span>
                    </Link>

                    <Link target="blank" to={"https://www.linkedin.com/in/scaleup-academy-9319b6378/"}>
                        <span>Linkedin</span>
                        <span>Linkedin</span>
                    </Link>
                </div>
            </div>


            {/* <Gallary /> */}


            <GetReady clean={true} logo={false} />
            <Footer />

        </>
    )
}
export default About